import Dexie, { type EntityTable } from 'dexie'
import { Client } from './client'
import { Product, SelectedProduct } from './product'
interface AdditionalInfo {
  name: string
  description: string
}

interface Authorization {
  status: string
  message: string
  description: string
}
interface PaymentMethod {
  name: string
  value: string
}
interface Invoice {
  id: string | null
  number: number | null
  client: Client | null
  products: SelectedProduct[]
  total: number
  tax: number
  discount: number | null
  code: string | null
  date: Date
  subtotal: number
  paymentMethod: PaymentMethod | null
  additionalFields: AdditionalInfo[]
  status: string | null
  authorization: Authorization[] | null
  isManual: boolean
  subtotalTarifaCero: number
  accountId?: number | null
}

export const defaultNewInvoice: Invoice = {
  id: null,
  number: null,
  client: null,
  products: [],
  subtotal: 0,
  total: 0,
  tax: 0,
  discount: 0,
  code: null,
  date: new Date(),
  paymentMethod: null,
  additionalFields: [],
  authorization: [
    {
      status: '',
      message: '',
      description: '',
    },
  ],
  status: '',
  isManual: false,
  subtotalTarifaCero: 0,
}

// Schema declaration:
const invoiceDB = new Dexie('ChullaAppInvoiceDatabase') as Dexie & {
  invoices: EntityTable<Invoice, 'id'>
}

invoiceDB.version(1).stores({
  invoices: '++id, code', // primary key "id" (for the runtime!)
})
export type { Invoice, AdditionalInfo, PaymentMethod }
export { invoiceDB }
